import { getStringHashCode26igk1bx568vk as getStringHashCode } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var SavePinInputClass;
function SavePinInput() {
  if (SavePinInputClass === VOID) {
    class $ {
      constructor(partyId, pinId, icon, name) {
        this.x6o_1 = partyId;
        this.y6o_1 = pinId;
        this.z6o_1 = icon;
        this.a6p_1 = name;
      }
      toString() {
        return 'SavePinInput(partyId=' + this.x6o_1.toString() + ', pinId=' + this.y6o_1.toString() + ', icon=' + this.z6o_1 + ', name=' + this.a6p_1 + ')';
      }
      hashCode() {
        var result = this.x6o_1.hashCode();
        result = imul(result, 31) + this.y6o_1.hashCode() | 0;
        result = imul(result, 31) + getStringHashCode(this.z6o_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.a6p_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof SavePinInput()))
          return false;
        if (!this.x6o_1.equals(other.x6o_1))
          return false;
        if (!this.y6o_1.equals(other.y6o_1))
          return false;
        if (!(this.z6o_1 === other.z6o_1))
          return false;
        if (!(this.a6p_1 === other.a6p_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'SavePinInput');
    SavePinInputClass = $;
  }
  return SavePinInputClass;
}
//region block: exports
export {
  SavePinInput as SavePinInputnc3r3ek8pldn,
};
//endregion

//# sourceMappingURL=SavePinInput.mjs.map
